
/*
Label - Display text for the filter
Values - key/val pairs (key: displaytext, val: value returned)
Action - callback for change per filter (optional)
Type - input control type for filter
resultProp - property name for results object
*/
export interface IFilter {
  label: string;
  values?: IFilterValue[];
  action?: (filterValue: string) => any | undefined;
  type: FilterType;
  propname: string;
}

export interface IFilterValue {
  key: string;
  val: any;
}

export enum FilterType{
  multiselect = 1,
  date = 2,
  dateRange = 3,
  select = 4,
  text = 5,
  ageRange = 6,
  checkbox = 7
}